export default {
    // 订单列表
    ordersList: {
        method: "get",
        url: "/orders"
    },
    // 订单筛选项
    ordersFilters: {
        method: "get",
        url: "/orders/filters"
    },
    // 订单详情
    ordersDetail: {
        method: "get",
        url: "/orders/:id"
    },
    // 订单编辑
    ordersEdit: {
        method: "patch",
        url: "/orders/:id"
    },
    // 订单工单
    orderWorkOrders: {
        method: "get",
        url: "/orders/:id/work_orders"
    },
    // 订单交易记录
    ordersTransactionRecords: {
        method: "get",
        url: "/orders/:id/transaction_records"
    }
};


// WEBPACK FOOTER //
// ./src/api/orders.js